import { render, staticRenderFns } from "./CampaignPMList.vue?vue&type=template&id=392ea55c"
import script from "./CampaignPMList.vue?vue&type=script&lang=js"
export * from "./CampaignPMList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports